import IReportDetails from '@/models/modelView/report-details';
import PikadayService from '@/services/pikaday.service';
import store from '@/store/index';
import dayjs from 'dayjs';
import { Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';

@Module({ dynamic: true, store, name: 'reports' })
class Reports extends VuexModule {

    picker = {
        fromDate: PikadayService.create('report-from-date', dayjs().toDate()),
        toDate: PikadayService.create('report-to-date', dayjs().toDate())
    }

    report_details: IReportDetails = {
        visible: false,
        icon: '0',
        plate: 'D7K-138',
        columns: [{ name: 'Kms', value: '456546' }]
    }

    report = {
        showGuides: true
    }

    @Mutation
    setReportDetails(details: any) {
        this.report_details = details
    }

    @Mutation
    setShowDetails(visible: boolean) {
        this.report_details.visible = visible
    }

    @Mutation
    setFromPicker(picker: any) {
        this.picker.fromDate = picker;
    }

    @Mutation
    setToPicker(picker: any) {
        this.picker.toDate = picker;
    }

    @Mutation
    setShowGuides(newVal: boolean) {
        this.report.showGuides = newVal;
    }

    get showGuides() {
        return this.report.showGuides
    }

}
export default getModule(Reports);